import './HistogramTooltip.css';
export var wrapper = '_16gfbaa0-2-0-1';